import React, {
  useEffect,
  useMemo,
} from 'react'

import PropTypes from 'prop-types'
// eslint-disable-next-line import/no-unresolved
import { useFocusTrap } from 'react-use-focus-trap'

import Styles from './styles.scss'

// TODO: why is this not in the stylesheet?
const MODAL_CONTENT_STYLES = {
  'modal-xl': {
    margin: '3% auto 20px',
    opacity: '1',
  },
  'modal-md': {
    margin: '3% auto 20px',
    opacity: '1',
  },
  'consent-banner': {
    opacity: '1',
  },
}


export default function Dialog({ ariaLabel, children, fixedBody, modalStyle, uiType }) {
  const [trapRef] = useFocusTrap()

  useEffect(() => {
    if ( !fixedBody ) {
      return
    }

    document.body.classList.add(Styles.preventBodyScroll)

    return () => {
      document.body.classList.remove(Styles.preventBodyScroll)
    }
  }, [fixedBody])

  const backgroundStyle = useMemo(() => {
    const styles = {
      ...MODAL_CONTENT_STYLES[uiType],
    }

    if ( modalStyle?.background ) {
      styles.background = modalStyle.background
    }

    return styles
  }, [modalStyle, uiType])

  return (
    <div
      className={ Styles.root }
      ref={ trapRef }
    >
      <div
        aria-label={ ariaLabel }
        className={ Styles[uiType] }
        role="alertdialog"
        style={ backgroundStyle }
      >
        { children }
      </div>
    </div>
  )
}

Dialog.propTypes = {
  ariaLabel: PropTypes.string,
  uiType: PropTypes.oneOf(
    Object.keys(MODAL_CONTENT_STYLES)
  ).isRequired,

  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  fixedBody: PropTypes.bool,
  modalStyle: PropTypes.shape({
    background: PropTypes.string,
  }),
}
